// extracted by mini-css-extract-plugin
export default {"cls1":"PostPrompt-cls1__d4496da3731b6f08113f","cls2":"PostPrompt-cls2___318495e7a81cf9ea7f4 PostPrompt-cls1__d4496da3731b6f08113f"};